import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    company: [
      { name: 'Sobre Nós', path: '/about-us' },
      { name: 'Processo Artesanal', path: '/artisanal-process' },
      { name: 'Galeria de Projetos', path: '/project-gallery' },
    ],
    services: [
      { name: 'Catálogo Interativo', path: '/interactive-catalog' },
      { name: 'Projetos Personalizados', path: '/contact-consultation' },
      { name: 'Manutenção e Restauro', path: '/contact-consultation' }
    ],
    support: [
      { name: 'Central de Ajuda', path: '/contact-consultation' },
      { name: 'Garantia Vitalícia', path: '/contact-consultation' },
      { name: 'Política de Privacidade', path: '/contact-consultation' },
      { name: 'Termos de Uso', path: '/contact-consultation' }
    ]
  };

  const socialLinks = [
    { name: 'Instagram', icon: 'Instagram', url: 'https://instagram.com/phmoveis' },
    { name: 'Facebook', icon: 'Facebook', url: 'https://facebook.com/phmoveis' },
    { name: 'YouTube', icon: 'Youtube', url: 'https://youtube.com/phmoveis' },
    { name: 'Pinterest', icon: 'Image', url: 'https://pinterest.com/phmoveis' }
  ];

  const certifications = [
    { name: 'FSC Certificado', icon: 'Shield' },
    { name: 'ISO 9001', icon: 'Award' },
    { name: 'Selo Verde', icon: 'Leaf' },
    { name: 'Artesão Brasil', icon: 'Star' }
  ];

  return (
    <footer className="bg-primary text-primary-foreground">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/homepage" className="flex items-center space-x-3 mb-6">
              <div className="flex flex-col">
                <span className="font-playfair font-bold text-2xl text-white">
                  PH Móveis
                </span>
                <span className="font-inter text-sm text-white/80 -mt-1">
                  Artesanais
                </span>
              </div>
            </Link>

            <p className="text-white/90 leading-relaxed mb-6">
              Criamos móveis únicos que contam sua história, combinando tradição artesanal brasileira 
              com design contemporâneo e materiais premium.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Icon name="Phone" size={16} color="white" />
                <span className="text-white/90 text-sm">(62) 99326-3202</span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Mail" size={16} color="white" />
                <span className="text-white/90 text-sm">phmoveisconteporaneos@gmail.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <Icon name="MapPin" size={16} color="white" className="mt-0.5" />
                <span className="text-white/90 text-sm">
                  Goiânia - GO • Brasília - DF
                </span>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-6">
              Empresa
            </h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-white/80 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-6">
              Serviços
            </h3>
            <ul className="space-y-3">
              {footerLinks?.services?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-white/80 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support & Newsletter */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-6">
              Suporte
            </h3>
            <ul className="space-y-3 mb-8">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-white/80 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Social Media & Certifications */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            {/* Social Links */}
            <div className="flex items-center space-x-6">
              <span className="text-white/80 text-sm font-medium">Siga-nos:</span>
              <div className="flex space-x-4">
                {socialLinks?.map((social, index) => (
                  <a
                    key={index}
                    href={social?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors duration-200"
                    aria-label={social?.name}
                  >
                    <Icon name={social?.icon} size={18} />
                  </a>
                ))}
              </div>
            </div>

            {/* Certifications */}
            <div className="flex items-center space-x-6">
              <span className="text-white/80 text-sm font-medium">Certificações:</span>
              <div className="flex space-x-4">
                {certifications?.map((cert, index) => (
                  <div
                    key={index}
                    className="flex items-center space-x-2 bg-white/10 rounded-full px-3 py-1"
                    title={cert?.name}
                  >
                    <Icon name={cert?.icon} size={14} color="white" />
                    <span className="text-white text-xs font-medium">{cert?.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-white/20 bg-trust">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-6 text-white/80 text-sm">
              <span>© {currentYear} PH Móveis Artesanais. Todos os direitos reservados.</span>
              <span className="hidden md:inline">•</span>
              <span className="hidden md:inline">CNPJ: 12.345.678/0001-90</span>
            </div>

            <div className="flex items-center space-x-6 text-white/80 text-sm">
              <span>Desenvolvido com</span>
              <Icon name="Heart" size={16} color="var(--color-accent)" className="fill-current" />
              <span>em São Paulo</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;